export default class ActivityModel {
  constructor(data) {
    this.userId = data.userId;
    this.sessions = data.sessions;
  }
}
